var render = function render(){var _vm=this,_c=_vm._self._c;return _c('landing-page-best-music')
}
var staticRenderFns = []

export { render, staticRenderFns }